import { jsx as _jsx } from "react/jsx-runtime";
import { ShoppingCartFillIcon } from '@yonderland/andes-icons';
import { ButtonAlpha, IconButton, useMediaQueryMatchesOnDesktop, } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { useProductDetailContext } from '../../../containers/product/ProductDetailV2Container';
export const AddToBasketButton = ({ onClick, quantity = 1, isStickyBar, isOneSizeProduct, disabled = false, buttonSize, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const isDesktop = useMediaQueryMatchesOnDesktop();
    const { ctaRef } = useProductDetailContext();
    const hideText = !isDesktop && isStickyBar && !isOneSizeProduct;
    const fullWidth = !isStickyBar;
    const handleClick = () => {
        onClick(quantity);
    };
    const icon = {
        source: ShoppingCartFillIcon,
        size: hideText ? 'xs' : 'sm',
    };
    const sharedButtonProps = {
        innerRef: !isStickyBar ? ctaRef : undefined,
        theme: 'branded',
        variant: 'primary',
        state: disabled ? 'disabled' : 'interactive',
        fullWidth,
        testId: 'add_to_basket',
        onClick: handleClick,
    };
    return hideText ? (_jsx(IconButton, Object.assign({}, sharedButtonProps, { icon: icon }))) : (_jsx(ButtonAlpha, Object.assign({}, sharedButtonProps, { text: t('product:pdp.cart.addtobasket.btn'), size: isStickyBar ? 'sm' : (buttonSize !== null && buttonSize !== void 0 ? buttonSize : 'md'), iconLeft: icon })));
};
